exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card--activity[data-v-0dbc168c], .card--activity *[data-v-0dbc168c] {\n  color: #000000;\n}\n.card--activity .card__deal-type h4[data-v-0dbc168c] {\n  font-weight: bold;\n}\n.card--activity .card__thumbnail[data-v-0dbc168c] {\n  width: 100%;\n  height: auto;\n  border-radius: 1rem;\n  overflow: hidden;\n  display: block;\n  line-height: 0;\n}\n.card--activity .card__thumbnail img[data-v-0dbc168c] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  max-width: initial;\n}", ""]);

// exports
